import { Component } from '@angular/core';

@Component({
  selector: 'app-hygine-link',
  templateUrl: './hygine-link.component.html',
  styleUrls: ['./hygine-link.component.scss']
})
export class HygineLinkComponent {

}
